import { useEffect } from "react";
import { Keyboard, type KeyboardEventListener } from "react-native";

type Params = {
  onShow: KeyboardEventListener;
  onHide: KeyboardEventListener;
};

export const useKeyboard = ({ onShow, onHide }: Params, dependencies: NotWorth[] = []) => {
  useEffect(() => {
    const keyboardShowListener = Keyboard.addListener("keyboardWillShow" as const, onShow);
    const keyboardHideListener = Keyboard.addListener("keyboardWillHide" as const, onHide);

    return () => {
      keyboardShowListener.remove();
      keyboardHideListener.remove();
    };
    // biome-ignore lint/correctness/useExhaustiveDependencies: skip
  }, dependencies);
};
